
import React, { Component } from "react";
import queryString from 'query-string';
// reactstrap components
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Container,
  Button,
  Media,
  UncontrolledTooltip,
  Row,
  Col,
  Progress
} from "reactstrap";

// connect
import connect from 'redux-connect-decorator';
import { questionBank } from '../../../../actions/questionActions';
import { startExam, saveExam, resetExam, viewExam } from '../../../../actions/examActions';
import { getUserInfo } from '../../../../actions/authActions';
import { pagination } from '../../../../utils/ccl-utils';
import { withRouter, Link } from 'react-router-dom';
import SimpleHeaderExam from '../../../../components/Headers/SimpleHeaderExam';
import McqSingleAnswer from './component/mcq-single-answer';
import QuestionPagination from './component/QuestionPagination';
import BankTimeCounter from './component/BankTimeCounter';
import QuestionLayout from './component/question-layout';
import ExamFinish from './component/ExamFinish';
import { RenderMultipleChoiceQuestion, CorrectAnswer } from './component/exam-components';
import { PteLoadingSpinner } from '../../common/LoadingSpinner/pte-loading-spinner';

@connect(
  state => ({
    data: state.question.data,
    loading: state.exam.loading,
    exam: state.exam.exam
  }),
  {
    viewExam,
    getUserInfo,
    resetExam
  }
)
class MultipleChoiceView extends Component<any, any> {
  state = {
    id: queryString.parse(this.props.location.search).id
  };

  componentDidMount() {
    if (!this.state.id) {
      console.log('exam page is invalid');
    } else {
      // this.props.questionBank();
      this.props.viewExam(this.state.id);
      this.props.getUserInfo();
    }
  }

  constructor(props) {
    super(props);
  }

  renderButton = () => {
    return <>
        <Link to={`/user/multiple-choice/list`}>
          <Button
            className="btn-benit-sm btn-benit-default float-right"
            type="button"
          >
            <span className="btn-inner--text hidden-lg-down">Back&nbsp;&nbsp;</span>
            <span className="btn-inner--icon mr-1">
              <i className="fas fa-ellipsis-v"></i>
            </span>
          </Button>
        </Link>
    </>
  }

  getUserAnswer = (question) => {
    const { exam } = this.props;
    return exam.answers[`${question._id}`];
  }

  render() {
    const { exam } = this.props;

    return (
      <>
        <SimpleHeaderExam name="Multiple choice view" parentName="Home" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              { exam && exam.questions ? 
                <Card>
                  <CardHeader>
                    <div className="grid-icon size-45 icon-question-bank mr-2"></div>
                    <div style={{ display: 'inline-block', position: 'absolute', top: '17px'}}>
                      <h3 className="mb-0">Multiple Choice  { exam.exam_title.toUpperCase() } </h3>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div className="text-center">
                      <div>
                        <span className="text-red"><strong>View result exam</strong></span>
                      </div>
                      <div>
                        <span className="text-red"><strong>Your score: {exam.score}/{ exam.questions.length }</strong></span>
                      </div>
                    </div>

                    { exam.questions.map((question, i) => 
                        <>
                          <div style={{ marginLeft: '20px' }}>
                            <RenderMultipleChoiceQuestion name={ question._id } answer={ this.getUserAnswer(question) } disabled question= { question } onChangeRadioValue={ null } />
                            <CorrectAnswer question = { question } />
                          </div>
                          <hr className="my-1"/>
                        </>
                      )
                    }
                  </CardBody>
                  <CardFooter className="exam-border-top">
                    { this.renderButton() }
                  </CardFooter>
                </Card>
                : <PteLoadingSpinner />  
              }
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default MultipleChoiceView;
